import { useTranslation } from 'react-i18next';

// JP unit strings that should be looked up in intake.units. Other units
// (mm, %, etc.) are language-neutral and pass through unchanged.
const TRANSLATABLE_UNITS = new Set(['段', '個', '枚', '階', '棟', '本']);

export function NumberWithUnit({
  value,
  onChange,
  unit,
  placeholder,
  min,
  max,
  step,
}: {
  value: number | undefined;
  onChange: (next: number | undefined) => void;
  unit: string;
  placeholder?: string;
  min?: number;
  max?: number;
  step?: number;
}) {
  const { t } = useTranslation('intake');
  const displayUnit = TRANSLATABLE_UNITS.has(unit)
    ? t(`units.${unit}`, { defaultValue: unit })
    : unit;
  return (
    <div className="flex items-center gap-2">
      <input
        type="number"
        value={value ?? ''}
        onChange={(e) => {
          const v = e.target.value;
          onChange(v === '' ? undefined : Number(v));
        }}
        placeholder={placeholder}
        min={min}
        max={max}
        step={step ?? 1}
        className="w-24 rounded-md border border-synergy-neutral-700/40 bg-white/60 px-2 py-1 text-sm"
      />
      <span className="text-xs text-synergy-text-tertiary">{displayUnit}</span>
    </div>
  );
}
